import { isArray, isString } from 'lodash';
import utils from '@/utils';
import store from '@/store';
/**
 * @description 权限检查
 * @param {String|Array} value 需要的权限
 * @param {Object}} config {Boolean} all 全部匹配
 * @param {Object}} config {Boolean} not 取反
 */

export default function permission() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$all = _ref.all,
      all = _ref$all === void 0 ? false : _ref$all,
      _ref$not = _ref.not,
      not = _ref$not === void 0 ? false : _ref$not;

  if (isArray(value) || isString(value)) {
    var permissions = store.state.d2admin.permission.permissions;
    var has = utils.helper[all ? 'allIn' : 'oneOf'](permissions, value);
    if (not) has = !has;
    return has;
  } else {
    return false;
  }
}